---
id: cover-letter-service-go
title: Cover letter service
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - cover-letter
  - transfer
  - microservice
---

## Product Overview

### Who it serves

This microservice supports internal user migration flows that need to transfer cover letter records between accounts.

### Primary workflow

An internal caller submits a transfer request, and the service reassigns all cover letter records from the old user to the new user.

### Business rules

Transfers are applied to every cover letter owned by the source user, and empty result sets are treated as successful no-op migrations.

### Outcomes

Cover letter ownership is updated so downstream product flows see the new user as the owner.

### Out of scope

Creating, editing, or rendering cover letters is not handled by this service.

### API documentation

[Internal API Documentation](https://wiki.rezi.ai/apis/cover-letter-service-go-api-docs)

## Technical Overview

### Architecture flow

The Gin route in `apps/micro-services/cover-letter-service-go/pkg/api/routes/routes.go` exposes `/v1/cover-letter/transfer-all` and calls into the transfer service.

### Entry points

- `TransferController.TransferAll` in `apps/micro-services/cover-letter-service-go/pkg/api/controllers/transfer.go` validates the request and invokes the transfer service.
- The OpenAPI spec generator entry point is `apps/micro-services/cover-letter-service-go/cmd/spec/main.go`.

### Key modules

Transfer logic lives in `apps/micro-services/cover-letter-service-go/pkg/services/transfers/transfers.go`, with persistence handled by Firestore repositories under `apps/micro-services/cover-letter-service-go/pkg/repo/firestore`.

### Data sources and sinks

The service reads and updates cover letter documents in Firestore.

### Integrations and side effects

Firebase initialization is required at startup, and the service mutates stored cover letter records as its primary side effect.

### Constraints and risks

Transfers require valid user identifiers, and large datasets may increase the duration of Firestore update operations.

## Changelog

- 2026-02-03: Can have custom token
- 2026-01-30: Added the OpenAPI spec generator entry point.
- 2026-01-30: Initial documentation.
